import { connect } from 'react-redux';

import { GET_LIST_ROOM_OF_PLACE, UPDATE_CLOSE_OPEN_ROOM } from 'store/place/actionTypes';

import OpenCloseRoom from './OpenCloseRoom';

const mapStateToProps = (state) => ({
  isLoadingUpdateCloseOpenRoom: state.Place.isLoadingUpdateCloseOpenRoom,

  roomOfPlaceList: state.Place.roomOfPlaceList,
  setting: state.Setting.setting,
});

const mapDispatchToProps = (dispatch) => ({
  actionGetListRoomsOfPlace: (payload) => {
    dispatch({
      type: GET_LIST_ROOM_OF_PLACE,
      payload,
    });
  },

  actionUpdateCloseOpenRoom: (payload) => dispatch({
    type: UPDATE_CLOSE_OPEN_ROOM,
    payload,
  }),
});

export default connect(mapStateToProps, mapDispatchToProps)(OpenCloseRoom);
